export const generatePageTitle = ({
  title,
  networkName,
  topicName,
}: {
  networkName?: string;
  title: string;
  topicName?: string;
}) => {
  const rightPart = topicName || networkName;

  return [title, rightPart].filter(Boolean).join(' | ');
};
